module.exports = __webpack_public_path__ + "static/media/banner.bd0a6546.jpg";